module.exports = __webpack_public_path__ + "static/media/gym.211fd48f.png";